import NavigationBar from "components/NavigationBar/NavigationBar";
import {GeneralPageTemplate as GeneralPageTemplateUI} from "@pinch-financial/pinch-ui-components";
import {getIsNavigationMenuEnabled} from "~/store/selectors/configurations";
import {useSelector} from "react-redux";

const LoadingPage = () => {
  const navigationBarEnabled = useSelector(getIsNavigationMenuEnabled);

  return (
    <>
      <NavigationBar />
      <GeneralPageTemplateUI
        loading
        navigationBar={navigationBarEnabled ? <NavigationBar /> : undefined}
      ></GeneralPageTemplateUI>
    </>
  );
};

export default LoadingPage;
